export const QuickEditor = {
  state: {
    recents: [],
    recentsIndex: 0,
    showLayers: true
  },
  data: {
    prevSelected: null
  },

  Header: {
    flow: 'x',
    align: 'center start',
    padding: 'Y Y1',
    gap: 'Z',
    width: '100%',

    Text: {
      tag: 'span',
      fontSize: 'Z2',
      maxWidth: '65%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    QuickEditorNavbar: {
      margin: '- - - auto'
    }
  },

  Content: {
    tag: 'div',
    class: 'layers',
    fontSize: 'A1',
    overflow: 'hidden auto',
    maxHeight: 'calc(100vh - D2 - W2)',
    padding: '0 Y1 Y1'
  },

  PromptAI: {
    margin: 'auto - -',
    order: 2,
    hide: true
  },

  flow: 'y',
  gap: '0',
  position: 'absolute',
  top: 'C+X2',
  padding: '0',
  left: '--canvas-gutter',
  round: 'Z2',
  borderColor: 'line',
  borderWidth: '1px',
  borderStyle: 'solid',
  theme: 'common-box',
  minWidth: 'H',
  width: 'H',
  fontSize: 'Y2',
  opacity: '0',

  onRender: (el) => {
    el.node.style.opacity = '0'
    el.node.style.pointerEvents = 'none'

    setInterval(() => {
      if (!el.node) return

      const s = el.state
      const selected = el.getSelectedKey()
      const editorActive = el.getCanvasScope('editorActive')

      if (!selected || editorActive === false) {
        if (el.node.style.opacity !== '0') {
          el.node.style.opacity = '0'
          el.node.style.pointerEvents = 'none'
        }
        if (el.data.prevSelected) {
          el.data.prevSelected = null
        }
        return
      }

      if (el.node.style.opacity === '0') {
        el.node.style.opacity = '1'
        el.node.style.pointerEvents = ''
      }

      if (selected !== el.data.prevSelected) {
        el.data.prevSelected = selected
        const selectedEl = el.getSelected()
        if (selectedEl?.state?.parse) {
          const componentState = el.call(
            'deepClone',
            selectedEl.state.parse()
          )
          componentState.showLayers =
            s.showLayers !== undefined ? s.showLayers : true
          componentState.recents = s.recents || []
          componentState.recentsIndex = s.recentsIndex || 0
          s.replace(componentState)

          // Set title text
          const textEl = el.Header?.Text
          if (textEl?.node) textEl.node.textContent = selected

          // Build recursive layer tree
          const cn = el.Content?.node
          if (cn && componentState.value && typeof componentState.value === 'object') {
            cn.style.display = ''
            cn.textContent = ''
            const isChild = (k, v) =>
              /^[A-Z]/.test(k) && v && typeof v === 'object' && !Array.isArray(v)
            const buildLayers = (obj, container, depth) => {
              const entries = Object.keys(obj).filter((k) => isChild(k, obj[k]))
              for (const k of entries) {
                const child = obj[k]
                const hasChildren = Object.keys(child).some((ck) =>
                  isChild(ck, child[ck])
                )
                const row = document.createElement('div')
                row.style.cssText =
                  'padding:1px 0;cursor:default;padding-left:' +
                  depth * 12 +
                  'px'
                const arrow = hasChildren ? '\u25B8 ' : '\u00B7 '
                row.textContent = arrow + k
                container.appendChild(row)
                if (hasChildren) {
                  const nested = document.createElement('div')
                  buildLayers(child, nested, depth + 1)
                  container.appendChild(nested)
                }
              }
            }
            buildLayers(componentState.value, cn, 0)
          }
        }
      }
    }, 100)
  }
}
